import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { type OverviewResponse } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

const { coachingAnalytics } = appStrings.modules;

export const useAgentContext = (overview: OverviewResponse) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.metrics.students,
    display: `Overview cards for total students, students active in the last 30 days${
      overview.coaches ? ', and coach headcount' : ''
    }, with the student count broken down by enrollment and by program.`,
    detail: [
      coachingAnalytics.metrics.studentsInfo,
      coachingAnalytics.metrics.engagementInfo,
      ...(overview.coaches ? [coachingAnalytics.metrics.coachesInfo] : []),
    ].join('\n\n'),
    data: {
      students: overview.students.total,
      by_stage: overview.students.by_stage,
      by_program: overview.students.by_program,
      recently_active: overview.recently_active,
      ...(overview.coaches ? { coaches: overview.coaches } : {}),
    },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.assessmentCoverage.title,
    display:
      'Horizontal bars showing the share of students who have completed each assessment: Blueprint, Are You On Track?, and Life Readiness.',
    detail: coachingAnalytics.assessmentCoverage.info,
    data: overview.completions,
  });
};
